import { AnswerEngineTypesEnum } from '../enums/answer-engine-types.enum';


export const answerEngineTypesToModelIdMap = new Map<AnswerEngineTypesEnum, string>([
    [ AnswerEngineTypesEnum.GEMINI,     'google/gemini-3-flash-preview'        ],
    [ AnswerEngineTypesEnum.CHATGPT,    'openai/gpt-5-mini'                    ],
    [ AnswerEngineTypesEnum.PERPLEXITY, 'perplexity/sonar'                     ],
    [ AnswerEngineTypesEnum.CLAUDE,     'anthropic/claude-sonnet-4-5-20250929' ],
    [ AnswerEngineTypesEnum.GROK,       'xai/grok-4.3'                         ]
]);
